import { MutationHookOptions } from "@apollo/client";

import useSettingsFormTemplateEditor_Shared_AddFormTemplateQuestion from "../api/useSettingsFormTemplateEditor_Shared_AddFormTemplateQuestion";
import useSettingsFormTemplateEditor_Shared_DeleteFormTemplateQuestion from "../api/useSettingsFormTemplateEditor_Shared_DeleteFormTemplateQuestion";
import useSettingsFormTemplateEditor_Shared_UpdateFormTemplateQuestion from "../api/useSettingsFormTemplateEditor_Shared_UpdateFormTemplateQuestion";
import { FormTemplateQuestionFormInputs } from "../components/FormTemplateQuestionForm";
import buildFormTemplateQuestionPayload from "../util/buildFormTemplateQuestionPayload";

type hookOptions = {
    refetchQueries?: MutationHookOptions["refetchQueries"];
    formTemplateId?: string;
};

export function useSettingsFormTemplateEditorData({ refetchQueries, formTemplateId }: hookOptions) {
    const addFormTemplateQuestionMutation =
        useSettingsFormTemplateEditor_Shared_AddFormTemplateQuestion(refetchQueries);

    const updateFormTemplateQuestionMutation = useSettingsFormTemplateEditor_Shared_UpdateFormTemplateQuestion();

    const deleteFormTemplateQuestionMutation =
        useSettingsFormTemplateEditor_Shared_DeleteFormTemplateQuestion(refetchQueries);

    const handleAddQuestion = async (data: FormTemplateQuestionFormInputs) => {
        if (!formTemplateId) {
            return;
        }

        const addPayload = {
            ...buildFormTemplateQuestionPayload(data),
            formTemplateId,
        };
        await addFormTemplateQuestionMutation.createFormTemplateQuestion(addPayload);
    };

    const handleUpdateQuestion = async (formTemplateQuestionId: string, data: FormTemplateQuestionFormInputs) => {
        const updatePayload = {
            ...buildFormTemplateQuestionPayload(data, { typeId: data.type.id, conditionId: data.condition.id }),
            formTemplateQuestionId,
        };

        await updateFormTemplateQuestionMutation.updateFormTemplateQuestion(updatePayload);
    };

    const editQuestionError = updateFormTemplateQuestionMutation.error || deleteFormTemplateQuestionMutation.error;

    return {
        addFormTemplateQuestionMutation,
        updateFormTemplateQuestionMutation,
        deleteFormTemplateQuestionMutation,
        handleAddQuestion,
        handleUpdateQuestion,
        editQuestionError,
    };
}
